<div
  class="bg-gray-200 rounded-lg p-16"
  [class]="colis.isLate ? 'urgentCard' : ''"
>
  <div class="flex justify-between items-center">
    <div class="grid">
      <div class="w-full h-30 mb-4 grid" *ngIf="selectedOption == 1">
        <span
          *ngIf="colis.hoursLate > 48"
          class="text-red-600 font-bold flex items-center text-2xl"
          ><mat-icon>error_outline</mat-icon> En Retard
        </span>
      </div>
      <div class="w-full h-30 mb-4 grid" *ngIf="selectedOption == 2">
        <span
          *ngIf="colis.hoursLate > 24"
          class="text-red-600 font-bold flex items-center text-2xl"
          ><mat-icon>error_outline</mat-icon> En Retard
        </span>
      </div>
      <span class="font-bold text-gray-500">Départ</span>
      <span class="text-blue-600 font-bold text-2xl">
        {{ colis.Colis_Depart || "Non Défini" }}
      </span>
      <span class="font-bold text-gray-700">{{
        colis.Colis_DateDepart || (selectedOption != 1 ? colis.Date_Create : "")
          | date: "dd-MM-yyyy h:mm"
      }}</span>
    </div>
    <div class="grid">
      <div
        class="w-full text-left mb-4"
        *ngIf="userIsAllowedToDelete && selectedOption != 3"
      >
        <div
          (click)="toEdit(colis)"
          class="
            w-30
            h-30
            bg-blue-700
            float-right
            justify-center
            items-center
            flex
            rounded-lg
            cursor-pointer
            text-center
            ml-4
          "
        >
          <mat-icon class="text-white text-base">edit</mat-icon>
        </div>
        <div
          *ngIf="selectedOption == 1"
          (click)="toDelete(colis)"
          class="
            w-30
            h-30
            bg-red-700
            float-right
            justify-center
            items-center
            flex
            rounded-lg
            cursor-pointer
            text-center
          "
        >
          <mat-icon class="text-white text-base">delete</mat-icon>
        </div>
      </div>
      <span class="font-bold text-gray-500 text-right">Arrivée</span>
      <span class="text-red-600 font-bold text-2xl text-right">{{
        colis.Colis_Arrive || "Non Défini"
      }}</span>
      <span
        *ngIf="selectedOption == 2"
        class="font-bold text-gray-700 text-right"
      >
        Encour ...
      </span>
      <span
        *ngIf="selectedOption == 3"
        class="font-bold text-gray-700 text-right"
      >
        {{ colis.Colis_DateArrive | date: "dd-MM-yyyy h:mm" }}</span
      >
    </div>
  </div>
  <hr class="border-gray-400 my-8" />
  <ng-container *ngIf="selectedOption == 2">
    <span class="font-bold text-gray-500"> CIRCUIT</span>
    <div class="flex">
      <ng-container *ngFor="let step of colis.track; index as is">
        <div class="grid">
          <span class="font-bold text-gray-700">{{ step.User_Id_Create }}</span>
          <span>{{ step.Date_Create | date: "dd-MM-yyyy h:mm" }}</span>
        </div>
        <div *ngIf="is != colis.track.length - 1" class="mr-3 text-red-700">
          →
        </div>
      </ng-container>
    </div>
    <hr class="border-gray-400 my-8" />
  </ng-container>
  <div class="flex justify-between items-center">
    <div class="grid text-center">
      <span class="font-bold text-gray-500">Référence</span>
      <span class="text-lg font-bold text-gray-700">
        {{ colis.Colis_Ref || "Non Défini" }}</span
      >
    </div>
    <div class="grid text-center">
      <span class="font-bold text-green-600 text-right">Code de colis</span>
      <span class="text-lg font-bold text-green-700">
        {{ colis.Colis_Code }}</span
      >
    </div>
    <div class="grid text-center">
      <span class="font-bold text-gray-500">Date création</span>
      <span class="text-lg font-bold text-gray-700">
        {{ colis.Date_Create | date: "dd-MM-yyyy h:mm" }}</span
      >
    </div>
  </div>

  <p class="mt-4 h-10">
    {{ colis.Colis_Texte }}
  </p>
</div>
